interface CardHeaderProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLElement>,
    HTMLElement
  > {}

export default function CardHeader({
  children,
  className = '',
  ...rest
}: CardHeaderProps) {
  return (
    <header className={`card-header ${className}`} {...rest}>
      {children}
    </header>
  );
}
